import { TSetupStateData } from './sliceSetupCommonTypes'

export const setup15Template: TSetupStateData = {
    Procedure: {
        allChecked: true,
        label: 'Procedure',
        items: {}
    },
    Cart: {
        allChecked: false,
        label: 'Cart',
        items: {
            '0': { checked: false, label: 'Place the Cart close to an electrical outlet' },
            '1': { checked: false, label: 'Lock the Cart casters' },
            '2': { checked: false, label: 'Plug the Cart into the electrical outlet' },
            '3': { checked: false, label: 'Check that the charging icon is shown on the Cart Control screen' },
            '4': { checked: false, label: 'Turn on perfusion console. Enter advanced mode and click "X"' },
            '5': { checked: false, label: 'Turn on ventilator' },
            '6': { checked: false, label: 'Install hydrostatic sensors onto hydrostatic sensor mount and connect cables to the cart hydrostatic sensor connectors' }
        }
    },
    System: {
        allChecked: false,
        label: 'System',
        items: {
            '0': { checked: false, label: 'Perform ‘Self-Test’ on cart control screen' },
            '1': { checked: false, label: 'Connect the oxygen supply to the ventilator inlet (on the back of the Cart)' },
            '2': { checked: false, label: 'Connect the medical air gas line to the ventilator inlet (on the back of the Cart)' },
            '3': { checked: false, label: 'Connect EVLP gas line to the connection on the back of the cart' },
            '4': { checked: false, label: 'Insert drip tray liner into the cart drip tray' },
            '5': { checked: false, label: 'Open blue flow sensor latch' },
            '6': { checked: false, label: 'Pull locking rods outward and place the Organ Chamber into the Cart' },
            '7': { checked: false, label: 'Press flow tubing into flow sensor and close the blue latch' },
            '8': { checked: false, label: 'Push locking rods inward to lock the organ chamber' },
            '9': { checked: false, label: 'Ensure temperature reading is present (room temperature)' },
            '10': { checked: false, label: 'Assemble LA knob onto organ chamber' },
            '11': { checked: false, label: 'Connect the hoses of the heater/cooler to the Chamber' }
        }
    },
    Ventilator: {
        allChecked: false,
        label: 'Ventilator',
        items: {
            '0': { checked: false, label: 'Connect exhalation valve and filter to the ventilator' },
            '1': { checked: false, label: 'Run system test, complete all steps, and connect artificial lung when prompted' },
            '2': { checked: false, label: 'Run breathing circuit test and complete all steps' },
            '3': { checked: false, label: 'Assemble ventilation filter branch, connect to ventilator tubing and organ chamber' },
            '4': { checked: false, label: 'Engage airway clamp' },
            '5': { checked: false, label: 'Select current patient' },
            '6': { checked: false, label: 'Ensure parameters are set for steady-state ventilation' }
        }
    },
    Priming: {
        allChecked: false,
        label: 'Priming',
        items: {
            '0': { checked: false, label: 'Enter the Prime System mode on the cart control screen' },
            '1': { checked: false, label: 'Pour 2.0 L of perfusate into the fill port. Close fill port. Ensure flow reading is present' },
            '2': {
                checked: false,
                label: 'Zero the perfusion flow sensor',
                labelRenderer: 'zeroFlowSensor'
            },
            '3': { checked: false, label: 'Gradually ramp up the perfusion flow to 6000 rpm to de-air the circuit. Ensure there are no air bubbles present in the circuit' },
            '4': {
                checked: false,
                label: 'Add EVLP medications to circuit',
                subItems: [
                    'o 500 mg methylprednisolone',
                    'o 3000 UI unfractionated heparin',
                    'o 500 mg antibiotic (imipenem/cilastatin)'
                ]
            },
            '5': { checked: false, label: 'Reduce pump speed to 2000 RPM' }
        }
    },
    Cannulae: {
        allChecked: false,
        label: 'Post-Cannulation',
        items: {
            '0': { checked: false, label: 'Enter the Run Perfusion mode on the Cart Control screen' },
            '1': { checked: false, label: 'Place cannulated lungs into the Organ Chamber' },
            '2': { checked: false, label: 'Connect the LA and PA cannula hydrostatic lines to the appropriately colored port on the organ chamber.' },
            '3': { checked: false, label: 'Connect the 72” extension lines from the hydrostatic port connection on the exterior of the organ chamber to the hydrostatic sensor' },
            '4': { checked: false, label: 'Flush the hydrostatic extension lines with sterile saline and ensure no air bubbles are present in the line' },
            '5': { checked: false, label: 'Level the pressure transducers to the height of the cannulas and zero on the patient monitor' },
        }
    },
    Start: {
        allChecked: false,
        label: 'Start',
        items: {
            '0': { checked: false, label: 'Occlude LA pressure control knob until a flow of 500 ml/min is achieved (maintain speed at 2000 RPM)' },
            '1': {
                checked: false,
                label: 'Connect the lungs to the circuit as follows:',
                subItems: [
                    'o Clamp the LA branch and open LA/PA connection. Direct flow into the PA cannula',
                    'o De-air lung through PA cannula. Adjust speed as needed',
                    'o Connect PA cannula to PA branch once de-aired',
                    'o Direct LA flow into the LA branch. Connect once de-aired',
                    'o Un-clamp LA branch and return pump speed to 2000 RPM. Ensure no air bubbles are present in circuit'
                ]
            }
        }
    }
}